module.exports = __webpack_public_path__ + "img/yellowgold.35c985b.jpg";